// Legacy HITL decision URL — the interview view moved to
// `/inbox/hitl/:runId` with the unified Inbox (2026-07 nav review).
// Redirect keeps old bookmarks/notification links working.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/triage/hitl/$runId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/inbox/hitl/$runId',
      params: { runId: params.runId },
      replace: true,
    });
  },
  component: () => null,
});
